import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Theme, useMediaQuery, Typography } from '@mui/material';
import { OrderStatus } from 'models/order';

type OrderStatusChipProps = {
    status: OrderStatus;
};
const OrderStatusChip: FC<OrderStatusChipProps> = ({ status }: OrderStatusChipProps) => {
    const { t: translate } = useTranslation(['orders']);
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

    const colorMap = {
        [OrderStatus.ALL]: '', // Ignore this, just to solve type issues
        [OrderStatus.DRAFT]: '#444',
        [OrderStatus.COMPLETED_DRAFT]: '#444',
        [OrderStatus.SENT_BY_CUSTOMER]: 'focus.dark',
        [OrderStatus.ACCEPTED_BY_LAB]: 'extra.dark',
        [OrderStatus.SENT_BY_LAB]: 'success.main',
        [OrderStatus.ORDER_APPROVED]: 'success.main',
        [OrderStatus.CANCELLED]: 'error.dark',
        [OrderStatus.DECLINED]: 'error.dark',
    };

    return (
        <Fragment>
            {isMobile ? (
                <Box
                    sx={{
                        width: 14,
                        height: 14,
                        borderRadius: 7,
                        backgroundColor: colorMap[status],
                    }}
                ></Box>
            ) : (
                <Typography
                    variant="body2"
                    sx={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        fontWeight: 600,
                        color: colorMap[status],
                    }}
                >
                    {translate(status)}
                </Typography>
            )}
        </Fragment>
    );
};

export default OrderStatusChip;
